import produce from 'immer';

import { defaultState } from './defaultState';
import type { HomePageTemplateView } from './types';

type State = typeof defaultState;

export const reducers = {
  clear: (): State => produce(defaultState, (draft) => draft),
  homePageRequested: (state: State): State => ({
    ...state,
    isLoading: true
  }),
  homePageLoadSuccess: (state: State, payload: HomePageTemplateView): State => ({
    ...state,
    ...payload,
    isLoading: false,
    hasPreloaded: true
  }),
  homePageLoadFailure: (state: State): State => ({
    ...state,
    isLoading: false,
    hasPreloaded: true,
    error: true
  })
};
